// extracted by mini-css-extract-plugin
export var pillWrapper = "_o9-0";
export var showOverflow = "_o9-1";